import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getPhotoCaptureQuestionnaireId, hasPhotoCaptureContextUpdated, getPhotoCaptureCompanyCode, photoCaptureUpdateContextDataAction, getPhotoCaptureIsTermsAndConditionAccepted, SinglePhotoUploadComponent, photoCaptureAttachmentDataAction, getPhotoCaptureAttachmentInfo, getPhotoCaptureContextId, getPhotoCaptureImageMaxWidth, photoCaptureResetContextAction, photoCaptureFileUploadFailedAction, getPhotoCaptureAssignmentSubType, getPhotoCaptureAssignmentType, photoCaptureIsFileUploadStartedAction, getPhotoCaptureDisableLibrary, photoCaptureUpdateAttachedArtifactIdSuccessAction, getPhotoCaptureAttachedArtifactIds, getPhotoCaptureFileSizeLimit, getShouldShowCommentBox } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion, hasQuestionnaireEvaluationSaved, getQuestionnaireEvaluationQuestionnaireQuestionId, questionnaireEvaluationSaveRequestAction, questionnaireEvaluationQuestionGetAction, getQuestionnaireEvaluationParentQuestionId } from "../../../domain/questionnaireEvaluation";
import { getGPCEvaluationDocId } from '../utilities';
import { getGPCAttachmentsFromQuestionnaireEvaluation, getGPCTheme } from '../selectors';
const mapStateToProps = (state) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isSaveSuccess: hasQuestionnaireEvaluationSaved(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        attachments: getGPCAttachmentsFromQuestionnaireEvaluation(state),
        contextId: getPhotoCaptureContextId(state),
        imageMaxWidth: getPhotoCaptureImageMaxWidth(state),
        assignmentType: getPhotoCaptureAssignmentType(state),
        assignmentSubType: getPhotoCaptureAssignmentSubType(state),
        disableLibrary: getPhotoCaptureDisableLibrary(state),
        parentQuestionId: getQuestionnaireEvaluationParentQuestionId(state),
        fileSizeLimit: getPhotoCaptureFileSizeLimit(state),
        attachedArtifactIds: getPhotoCaptureAttachedArtifactIds(state),
        shouldShowCommentBox: getShouldShowCommentBox(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionnaireEvaluationQuestionGetAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureUpdateContextDataAction,
        photoCaptureAttachmentDataAction,
        photoCaptureResetContextAction,
        photoCaptureFileUploadFailedAction,
        photoCaptureIsFileUploadStartedAction,
        photoCaptureUpdateAttachedArtifactIdSuccessAction
    }, dispatch);
};
export const ConnectedSinglePhotoUpload = connect(mapStateToProps, mapDispatchToProps)(SinglePhotoUploadComponent);
//# sourceMappingURL=ConnectedSinglePhotoUpload.js.map